import React, { useEffect, useState } from "react";
import NotesPopUpModal from "./NotesPopUpModal";

interface DailyItem {
  activityDate: string;
  activityCount: number;
  displayText: string;
}

interface Props {
  data: DailyItem[];

  selectedDate: string | null; // which accordion is open
  onDateSelect: (date: string) => void; // when user clicks a date
  selectedYear: number | null;
  activityData: any[]; // data inside accordion

  onLoadMore: () => void; // show more click
  onShowLess: () => void; // show less click
  allLoaded: boolean; // toggle button state
  totalRows: number;
}

const DailySummaryAccordion: React.FC<Props> = ({
  data,
  onDateSelect,
  selectedYear,
  activityData,
  onLoadMore,
  onShowLess,
  allLoaded,
  totalRows,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const getFormattedDate = (dateStr: string) => dateStr.split("T")[0];

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    if (data.length > 0) {
      setOpenIndex(0);

      const firstDate = data[0].activityDate.split("T")[0];
      onDateSelect(firstDate);
    }
  }, [data, selectedYear]);

  const [showModal, setShowModal] = useState(false);
  const [selectedKeyId, setSelectedKeyId] = useState<number | null>(null);

  const handleOpenModal = (keyId: number) => {
    setSelectedKeyId(keyId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedKeyId(null);
  };
  return (
    <>
      <div className="daily-accordion">
        {data.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className="accordion-item-wrapper"
              style={{
                marginBottom: "10px",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                overflow: "hidden",
                background: "#fff",
              }}
            >
              {/* HEADER */}
              <div
                className="accordion-header d-flex justify-content-between align-items-center"
                onClick={() => {
                  const formattedDate = item.activityDate.split("T")[0];

                  // open new accordion
                  setOpenIndex(index);

                  // reset pagination + data from parent
                  onShowLess();

                  // set selected date
                  onDateSelect(formattedDate);
                }}
              >
                <div>
                  <strong>{formatDate(item.activityDate)} &nbsp;&nbsp;</strong>
                  <span className="activity_badge">
                    <strong>{item.activityCount} Activity</strong>
                  </span>
                </div>

                <span className="material-symbols-outlined">
                  {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
              </div>

              {/* BODY */}
              {isOpen && (
                <div className="accordion-body">
                  {activityData && activityData.length > 0 ? (
                    activityData.map((row: any) => (
                      <div
                        key={row.keyId}
                        className="row align-items-center border py-1 flex-nowrap p-0 m-0 activity_wrap mb-2 fade-in-left"
                      >
                        {/* Column 1 - Type + Summary */}
                        <div className="col-md-2 d-flex align-items-center gap-1 border-right_act">
                          {row.sourceType === "Notes" ? (
                            <span
                              className="material-symbols-outlined"
                              title="Type"
                              style={{
                                color: "#1976d2",
                                border: "1px solid #0092d5",
                                borderRadius: "10%",
                                width: "25px",
                                height: "25px",
                                fontSize: "18px",
                                padding: "2px",
                              }}
                            >
                              draw
                            </span>
                          ) : row.sourceType === "Activity" ? (
                            <span
                              className="material-symbols-outlined"
                              title="Activity"
                              style={{
                                color: "#d32f2f",
                                border: "1px solid #dc3545",
                                borderRadius: "10%",
                                width: "25px",
                                height: "25px",
                                fontSize: "18px",
                                padding: "2px",
                              }}
                            >
                              manage_history
                            </span>
                          ) : null}

                          <span
                            className="text-truncate"
                            style={{ fontWeight: "600" }}
                          >
                            {row.activitySummary}
                          </span>
                        </div>

                        {/* Column 2 - Attachment */}
                        <div className="col-md-1 text-center  border-right_act">
                          <span>
                            {" "}
                            {row.fileCount === 0 ? (
                              "-"
                            ) : (
                              <span
                                className="d-inline-flex align-items-center gap-1 cursor-pointer attachfile "
                                onClick={() => handleOpenModal(row.keyId)}
                              >
                                <span
                                  className="material-icons"
                                  title="Attchment"
                                >
                                  attachment
                                </span>
                                {row.fileCount}
                              </span>
                            )}
                          </span>
                        </div>

                        {/* Column 3 - Added By */}
                        <div className="col-md-2 d-flex align-items-center gap-1  border-right_act">
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#F19E39" }}
                            title="Added By"
                          >
                            person
                          </span>
                          <span
                            className="text-truncate"
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                              lineHeight: "15px",
                            }}
                          >
                            {row.addedBy}
                          </span>
                        </div>

                        {/* Column 4 - Time */}
                        <div className="col-md-1 d-flex align-items-center gap-1  border-right_act p-0 justify-content-center">
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#634FA2" }}
                            title="Time"
                          >
                            acute
                          </span>
                          <span style={{ color: "#634FA2" }}>
                            {" "}
                            {row.transactionTime}
                          </span>
                        </div>

                        {/* Column 5 - Elapsed */}
                        <div className="col-md-1 d-flex align-items-center gap-1  border-right_act p-0 justify-content-center">
                          <span
                            className="material-symbols-outlined"
                            style={{ color: "#278587" }}
                            title="Elapsed Time"
                          >
                            avg_pace
                          </span>
                          <span style={{ color: "#278587", fontWeight: "600" }}>
                            {row.elapsedTime}
                          </span>
                        </div>

                        {/* Column 6 - Description (BIG - 7 cols) */}
                        <div className="col-md-5 d-flex align-items-center gap-1">
                          <span
                            className="material-symbols-outlined"
                            title="Activity Description"
                          >
                            speaker_notes
                          </span>

                          <div
                            className="text-truncate"
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: row.activityDescription,
                            }}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-danger fw-bold py-3">
                      No records found
                    </div>
                  )}

                  {/* Show More / Less */}
                  {activityData &&
                    activityData.length > 0 &&
                    totalRows > 10 && (
                      <div
                        className="d-flex justify-content-end align-items-center gap-2 p-2 fw-bold cursor-pointer"
                        onClick={allLoaded ? onShowLess : onLoadMore}
                      >
                        <span>{allLoaded ? "Show Less" : "Show More"}</span>
                        <span className="material-symbols-outlined">
                          {allLoaded ? "expand_less" : "expand_more"}
                        </span>
                      </div>
                    )}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <NotesPopUpModal
        show={showModal}
        onClose={handleCloseModal}
        keyId={selectedKeyId}
      />
    </>
  );
};

export default DailySummaryAccordion;
